// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VpnL","toggle":"styles_toggle__2DlZn","preview":"styles_preview__19DjT"};